import React from 'react';
import { Script } from 'gatsby';
import styled from 'styled-components';

const StyledVideo = styled.div`
  /* height: 33.5rem; */
  overflow: hidden;
`;

const Video = ({ src, title }) => {
  return (
    <StyledVideo>
      <div
        className="wistia_responsive_padding"
        style={{
          padding: '56.25% 0 0 0',
          position: 'relative',
        }}
      >
        <div
          className="wistia_responsive_wrapper"
          style={{
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
          }}
        >
          <iframe
            src={src}
            title={title}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowtransparency="true"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
          />
        </div>
      </div>
      <Script src="https://fast.wistia.net/assets/external/E-v1.js" async />
    </StyledVideo>
  );
};

export default Video;
